import axios from 'axios';

const cancelRemaining = async (
  listingId: string,
  appointmentsToCancel: Record<string, boolean>,
) => {
  await axios.post(
    `/listing/${listingId}/appointments/config/cancelRemaining`,
    {
      appointmentsToCancel,
    },
  );
};

export default cancelRemaining;
